import React from 'react';
import Icon from '../../../components/AppIcon';

const MapLegend = ({ isOpen, onToggle }) => {
  const legendItems = [
    { color: 'bg-[#4caf50]', label: 'Protected Zones', icon: 'Shield' },
    { color: 'bg-[#ff9800]', label: 'Moderate Threat Areas', icon: 'AlertTriangle' },
    { color: 'bg-[#f44336]', label: 'Critical Threat Zones', icon: 'AlertOctagon' },
    { color: 'bg-[#2196f3]', label: 'Visitor Trails', icon: 'Route' },
    { color: 'bg-[#9c27b0]', label: 'Ranger Patrol Routes', icon: 'Users' },
    { color: 'bg-[#ffc107]', label: 'Biodiversity Hotspots', icon: 'Sparkles' },
    { color: 'bg-[#00bcd4]', label: 'Water Bodies', icon: 'Droplets' },
    { color: 'bg-[#795548]', label: 'Research Stations', icon: 'Microscope' }
  ];

  return (
    <div className={`absolute top-4 right-4 bg-card rounded-lg shadow-conservation-lg transition-all duration-300 z-[400] ${isOpen ? 'w-72' : 'w-12'}`}>
      <button
        onClick={onToggle}
        className="w-full p-3 flex items-center justify-between hover:bg-muted/50 rounded-t-lg transition-colors"
        aria-label={isOpen ? 'Close legend' : 'Open legend'}
      >
        <span className={`font-medium text-foreground ${isOpen ? 'block' : 'hidden'}`}>Map Legend</span>
        <Icon name={isOpen ? 'ChevronRight' : 'Map'} size={20} color="var(--color-foreground)" />
      </button>
      {isOpen && (
        <div className="p-4 space-y-3 max-h-96 overflow-y-auto">
          {legendItems?.map((item, index) => (
            <div key={index} className="flex items-center gap-3 animation-organic hover:bg-muted/30 p-2 rounded">
              <div className={`w-4 h-4 rounded ${item?.color} flex-shrink-0`}></div>
              <Icon name={item?.icon} size={16} color="var(--color-muted-foreground)" />
              <span className="text-sm text-foreground">{item?.label}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MapLegend;